/**
 * @fileoverview gRPC-Web generated client stub for adx.dynamic_dimension_report
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.adx = {};
proto.adx.dynamic_dimension_report = require('./dynamic_dimension_report_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.adx.dynamic_dimension_report.DynamicDimensionReportClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.adx.dynamic_dimension_report.DynamicDimensionReportPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryMonthlyReportRequest,
 *   !proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryMonthlyReportResponse>}
 */
const methodDescriptor_DynamicDimensionReport_GetAdProviderDynamicCategoryMonthlyReport = new grpc.web.MethodDescriptor(
  '/adx.dynamic_dimension_report.DynamicDimensionReport/GetAdProviderDynamicCategoryMonthlyReport',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryMonthlyReportRequest,
  proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryMonthlyReportResponse,
  /**
   * @param {!proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryMonthlyReportRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryMonthlyReportResponse.deserializeBinary
);


/**
 * @param {!proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryMonthlyReportRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryMonthlyReportResponse>}
 *     The XHR Node Readable Stream
 */
proto.adx.dynamic_dimension_report.DynamicDimensionReportClient.prototype.getAdProviderDynamicCategoryMonthlyReport =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/adx.dynamic_dimension_report.DynamicDimensionReport/GetAdProviderDynamicCategoryMonthlyReport',
      request,
      metadata || {},
      methodDescriptor_DynamicDimensionReport_GetAdProviderDynamicCategoryMonthlyReport);
};


/**
 * @param {!proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryMonthlyReportRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryMonthlyReportResponse>}
 *     The XHR Node Readable Stream
 */
proto.adx.dynamic_dimension_report.DynamicDimensionReportPromiseClient.prototype.getAdProviderDynamicCategoryMonthlyReport =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/adx.dynamic_dimension_report.DynamicDimensionReport/GetAdProviderDynamicCategoryMonthlyReport',
      request,
      metadata || {},
      methodDescriptor_DynamicDimensionReport_GetAdProviderDynamicCategoryMonthlyReport);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryWeeklyReportRequest,
 *   !proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryWeeklyReportResponse>}
 */
const methodDescriptor_DynamicDimensionReport_GetAdProviderDynamicCategoryWeeklyReport = new grpc.web.MethodDescriptor(
  '/adx.dynamic_dimension_report.DynamicDimensionReport/GetAdProviderDynamicCategoryWeeklyReport',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryWeeklyReportRequest,
  proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryWeeklyReportResponse,
  /**
   * @param {!proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryWeeklyReportRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryWeeklyReportResponse.deserializeBinary
);


/**
 * @param {!proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryWeeklyReportRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryWeeklyReportResponse>}
 *     The XHR Node Readable Stream
 */
proto.adx.dynamic_dimension_report.DynamicDimensionReportClient.prototype.getAdProviderDynamicCategoryWeeklyReport =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/adx.dynamic_dimension_report.DynamicDimensionReport/GetAdProviderDynamicCategoryWeeklyReport',
      request,
      metadata || {},
      methodDescriptor_DynamicDimensionReport_GetAdProviderDynamicCategoryWeeklyReport);
};


/**
 * @param {!proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryWeeklyReportRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryWeeklyReportResponse>}
 *     The XHR Node Readable Stream
 */
proto.adx.dynamic_dimension_report.DynamicDimensionReportPromiseClient.prototype.getAdProviderDynamicCategoryWeeklyReport =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/adx.dynamic_dimension_report.DynamicDimensionReport/GetAdProviderDynamicCategoryWeeklyReport',
      request,
      metadata || {},
      methodDescriptor_DynamicDimensionReport_GetAdProviderDynamicCategoryWeeklyReport);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryDailyReportRequest,
 *   !proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryDailyReportResponse>}
 */
const methodDescriptor_DynamicDimensionReport_GetAdProviderDynamicCategoryDailyReport = new grpc.web.MethodDescriptor(
  '/adx.dynamic_dimension_report.DynamicDimensionReport/GetAdProviderDynamicCategoryDailyReport',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryDailyReportRequest,
  proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryDailyReportResponse,
  /**
   * @param {!proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryDailyReportRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryDailyReportResponse.deserializeBinary
);


/**
 * @param {!proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryDailyReportRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryDailyReportResponse>}
 *     The XHR Node Readable Stream
 */
proto.adx.dynamic_dimension_report.DynamicDimensionReportClient.prototype.getAdProviderDynamicCategoryDailyReport =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/adx.dynamic_dimension_report.DynamicDimensionReport/GetAdProviderDynamicCategoryDailyReport',
      request,
      metadata || {},
      methodDescriptor_DynamicDimensionReport_GetAdProviderDynamicCategoryDailyReport);
};


/**
 * @param {!proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryDailyReportRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.adx.dynamic_dimension_report.GetAdProviderDynamicCategoryDailyReportResponse>}
 *     The XHR Node Readable Stream
 */
proto.adx.dynamic_dimension_report.DynamicDimensionReportPromiseClient.prototype.getAdProviderDynamicCategoryDailyReport =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/adx.dynamic_dimension_report.DynamicDimensionReport/GetAdProviderDynamicCategoryDailyReport',
      request,
      metadata || {},
      methodDescriptor_DynamicDimensionReport_GetAdProviderDynamicCategoryDailyReport);
};


module.exports = proto.adx.dynamic_dimension_report;

